import {AppState} from '../../index';


export const selectOnlineState = (state: AppState) => state.applicationHealthState.online;
export const selectRecoverableErrors = (state: AppState) => state.applicationHealthState.recoverableErrors;
